import { render, staticRenderFns } from "./BulkRecipientList.vue?vue&type=template&id=fe4d174c&scoped=true"
import script from "./BulkRecipientList.vue?vue&type=script&lang=js"
export * from "./BulkRecipientList.vue?vue&type=script&lang=js"
import style0 from "./BulkRecipientList.vue?vue&type=style&index=0&id=fe4d174c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4d174c",
  null
  
)

export default component.exports